import { gql, TypedDocumentNode } from "@apollo/client";
import type {
  CreateUniversityStaffResponse,
  CreateUniversityStaffVariables,
  DeleteUniversityStaffResponse,
  DeleteUniversityStaffVariables,
  UpdateUniversityStaffResponse,
  UpdateUniversityStaffVariables
} from "./types";

export const CREATE_UNIVERSITY_STAFF_MUTATION: TypedDocumentNode<
  CreateUniversityStaffResponse,
  CreateUniversityStaffVariables
> = gql`
  mutation CreateUniversityStaff($input: BackofficeEducationCreateUniversityStaffInput!) {
    createUniversityStaff(input: $input) {
      success
      message
      universityStaff {
        id
        role
        user {
          id
          name
          email
        }
      }
    }
  }
`;

export const UPDATE_UNIVERSITY_STAFF_MUTATION: TypedDocumentNode<
  UpdateUniversityStaffResponse,
  UpdateUniversityStaffVariables
> = gql`
  mutation UpdateUniversityStaff($input: BackofficeEducationUpdateUniversityStaffInput!) {
    updateUniversityStaff(input: $input) {
      success
      message
      universityStaff {
        id
        role
      }
    }
  }
`;

export const DELETE_UNIVERSITY_STAFF_MUTATION: TypedDocumentNode<
  DeleteUniversityStaffResponse,
  DeleteUniversityStaffVariables
> = gql`
  mutation DeleteUniversityStaff($id: ID!) {
    deleteUniversityStaff(id: $id) {
      success
      message
    }
  }
`;
